var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.options.length
    ? _c("p", { staticClass: "company-switcher__empty" }, [
        _vm._v(" " + _vm._s(_vm.$t("nenhumaempresaencontrada")) + " "),
      ])
    : _c(
        "ul",
        {
          ref: "list",
          staticClass: "company-switcher__list",
          attrs: {
            id: _vm.listboxId,
            role: "listbox",
            "aria-label": _vm.$t("empresas"),
          },
          on: {
            mousedown: function ($event) {
              $event.preventDefault()
            },
          },
        },
        _vm._l(_vm.options, function (option, index) {
          return _c("company-switcher-option", {
            key: option.value,
            attrs: {
              id: _vm.optionId(index),
              label: option.label,
              selected: option.value === _vm.currentValue,
              active: index === _vm.activeIndex,
            },
            nativeOn: {
              mousemove: function ($event) {
                return _vm.$emit("activate", index)
              },
              click: function ($event) {
                return _vm.$emit("select", option.value)
              },
            },
          })
        }),
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }